module.exports = __webpack_public_path__ + "@/assets/img/barcode.071b970e.png";